import React from 'react'
import { Route, Switch } from 'react-router-dom'

import {
  OrderListPage,
  OrderPage,
  ShipmentListPage,
  ShipmentPage,
} from './pages/parcel'

export const ParcelRouter = () => {
  return (
    <Switch>
      <Route path='/parcel/orders/:guid' component={OrderPage} exact />
      <Route path='/parcel/orders' component={OrderListPage} exact />
      <Route path='/parcel/shipments/:guid' component={ShipmentPage} exact />
      <Route path='/parcel/shipments' component={ShipmentListPage} exact />
    </Switch>
  )
}
